import React from 'react';
import { motion } from 'framer-motion';
import { Brain, LifeBuoy, PenLine, Sunrise, Sparkles, BoxIcon } from 'lucide-react';
const BONUSES = [{
  icon: Brain,
  title: 'Reset Mental de 7 Días',
  value: '$6.990',
  desc: 'Frená el ruido mental y empezá liviano.'
}, {
  icon: LifeBuoy,
  title: 'Frases SOS',
  value: '$5.990',
  desc: 'Qué decirte en tus peores momentos.'
}, {
  icon: PenLine,
  title: 'Creá tus Afirmaciones',
  value: '$5.990',
  desc: 'Diseñá las frases que TU mente necesita.'
}, {
  icon: BoxIcon,
  title: 'Dejá de Compararte',
  value: '$6.990',
  desc: 'Liberate de las redes y la opinión ajena.'
}, {
  icon: Sunrise,
  title: 'Los Primeros 5 Minutos',
  value: '$5.990',
  desc: 'El ritual que decide cómo te va el día.'
}, {
  icon: Sparkles,
  title: 'Detox de Pensamientos',
  value: '$6.990',
  desc: 'Vaciá tu cabeza y soltá lo que te pesa.'
}];
export function Bonuses() {
  return <section className="py-20 px-4 bg-brown text-cream" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12 text-gold" data-id="element-23">
          Además, hoy sumás 6 bonos gratis
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-24">
          {BONUSES.map((bono, i) => {
          const Icon = bono.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white/5 border border-white/10 p-6 rounded-2xl hover:bg-white/10 transition-colors" data-id="element-25">
                <div className="flex items-center gap-4 mb-3" data-id="element-26">
                  <div className="p-3 bg-gold/20 rounded-xl text-gold" data-id="element-27">
                    <Icon className="w-6 h-6" data-id="element-28" />
                  </div>
                  <div data-id="element-29">
                    <h3 className="font-sans font-bold text-lg leading-tight" data-id="element-30">
                      {bono.title}
                    </h3>
                    <p className="font-sans text-xs text-cream/50 line-through mt-1" data-id="element-31">
                      valor {bono.value}
                    </p>
                  </div>
                </div>
                <p className="font-sans text-sm text-cream/80" data-id="element-32">{bono.desc}</p>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-33">
          <p className="inline-block px-6 py-3 bg-gold/20 border border-gold/40 rounded-full font-sans font-bold text-lg text-gold" data-id="element-34">
            Valor total de los bonos:{' '}
            <span className="line-through opacity-70" data-id="element-35">$38.940</span> — hoy
            GRATIS.
          </p>
        </div>
      </div>
    </section>;
}